<script setup>
import {format} from "date-fns";

const {selected, times, courses} = defineProps(['selected', 'times', 'courses']);

const subscription = selected[ selected.length - 1 ];
</script>

<template>
    <div class="border rounded-3xl p-5 sm:p-10 lg:sticky lg:top-10">
        <h3 class="text-white text-xl font-bold mb-5">Résumé</h3>

        <p class="text-white text-lg border-purple mb-5 pb-2" :class="{
            'border-b': !(['limited_pass', 'session_pass'].includes(subscription.subscription_type))
        }">
            <span class="block mb-2 font-bold" v-for="item in selected" v-html="item.title"></span>
            <span class="block">{{ subscription.price }} &euro; {{ subscription.price_detail }}</span>
        </p>

        <ul class="text-white text-lg flex flex-col gap-y-2">
            <li class="block" v-if="subscription.subscription_type === 'special_pass'">
                <i class="fa-fw fa-solid fa-check text-purple"></i> <strong class="font-bold">{{ times.dance }}</strong> {{ times.dance > 1 ? 'séances' : 'séance' }} de danse par semaine
            </li>

            <li class="block" v-if="subscription.subscription_type === 'special_pass'">
                <i class="fa-fw fa-solid fa-check text-purple"></i> <strong class="font-bold">{{ times.fitness }}</strong> {{ times.fitness > 1 ? 'séances' : 'séance' }} de fitness par semaine
            </li>

            <li v-if="['dance_pass', 'fitness_pass', 'special_pass'].includes(subscription.subscription_type)" v-for="detail in subscription.details">
                <i class="fa-fw fa-solid fa-check text-purple"></i> {{ detail }}
            </li>

            <li v-if="['dance_pass', 'special_pass'].includes(subscription.subscription_type)" v-for="course in courses">
                <i class="fa-fw fa-solid fa-check text-purple"></i> <span class="border-b">{{ course.title }}</span><br/>
                <span class="pl-7">le {{ format( course.scheduled_date, 'eeee' ) }} de {{ course.schedule_start }} à {{ course.schedule_end }}</span>
            </li>

            <li v-if="['limited_pass', 'session_pass'].includes(subscription.subscription_type)" v-for="detail in subscription.details">
                <i class="fa-fw fa-solid fa-check text-purple"></i> {{ detail }}
            </li>
        </ul>
    </div>
</template>